import { client, unwrap } from './client';

export interface ApiKey {
  _id: string;
  name: string;
  keyPrefix: string;
  status: string;
  lastUsedAt: string | null;
  allowedModels: string[];
  createdAt: string;
}

export interface NewKeyResponse {
  id: string;
  name: string;
  keyPrefix: string;
  apiKey: string; // raw — shown once
}

export const listKeys = (): Promise<ApiKey[]> =>
  unwrap(client.get('/inference-customer/keys'));

export const createKey = (
  name: string,
  allowedModels: string[] = []
): Promise<NewKeyResponse> =>
  unwrap(client.post('/inference-customer/keys', { name, allowedModels }));

export const revokeKey = (id: string): Promise<{ id: string; status: string }> =>
  unwrap(client.delete(`/inference-customer/keys/${id}`));
